import reducer from "./reducers";

import * as providerAction from "./actions";

export { providerAction };

export default reducer;
